module.exports = __webpack_public_path__ + "img/ceaslov-1715-pagina-de-titlu-big.e7f35f84.jpg";